// @ts-nocheck
import * as React from 'react'
import { AutoComplete, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { GridCellProps } from '@progress/kendo-react-grid'
import { Checkbox as KCheckbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { AttributeModal, ScrollDialog, ImageDialog } from './Modals'
import _ from 'lodash'
import { getBaseURL } from '../../GlobalComponents/URLs'

const PART_SEARCH_URI = `${getBaseURL()}webapi/invtcategoryattribute/acParts`
const PART_IMAGE_URL = `${getBaseURL()}invtforms/invtimage.ashx?PartKey=`

interface GridCellState {}
interface GridPartProps extends GridCellProps {
    enterEdit?: any
    onMouseDown?: any
    onMouseUp?: any
    onMouseOver?: any
    setRowLoading?: any
}

interface GridPartState {
    value: string
    originalValue: string
    loading: boolean
    options: Array<string>
    focused: boolean
}

interface GridCheckProps extends GridCellProps {}

interface GridCheckState {
    value: boolean
}

interface GridDQIProps extends GridCellProps {}

interface GridDQIState {
    value: number
}

interface GridImageProps extends GridCellProps {}

interface GridImageState {
    value: string
    currentModal: any
}

export const ImageComponent = (props: GridImageProps) => {
    // const [value, setValue] = React.useState(props.dataItem)
    const [currentModal, setCurrentModal] = React.useState<any>(null)

    // static getDerivedStateFromProps(props, current_state) {
    //   if(props.dataItem[this.props])
    // }

    const onChange = (e, value) => {
        props.onChange({
            dataItem: props.dataItem,
            syntheticEvent: e,
            field: props.field,
            value: value,
        })
    }

    const handleChange = (opt) => {
        //   const {onCommit, onRevert} = this.props
        //   if (!opt) {
        //     return onRevert()
        //   }
        //   const { e } = this.state
        //   onCommit(opt.value, e)
    }

    let value = props.dataItem[props.field]
    let cellField = 'Image'
    let dataItem = props.dataItem
    let disabled = !!!dataItem['Part Number']
    let partKey = dataItem['Partkey']
    let imageSrc =
        typeof value === 'boolean'
            ? PART_IMAGE_URL + partKey + '&ignorecaching=' + Math.random() * 89999 + 10000
            : value
    let text = value ? 'Yes' : 'No'
    const selected = props.dataItem['selected'] && props.dataItem.selectedColumns[props.field]
    const { onMouseOver, onMouseDown, onMouseUp } = dataItem
    return (
        <>
            <td
                onClick={(e) => {
                    e.persist()
                    if (!disabled)
                        setCurrentModal(
                            <ImageDialog
                                open={true}
                                close={() => setCurrentModal(null)}
                                onSave={(value) => {
                                    onChange(e, value)
                                }}
                                src={imageSrc}
                            />
                        )
                }}
                onMouseDown={(e) => {
                    onMouseDown(e, dataItem, cellField)
                }}
                onMouseOver={(e) => {
                    onMouseOver(e, dataItem, cellField)
                }}
                onMouseUp={(e) => {
                    onMouseUp(e, dataItem, cellField)
                }}
                style={{
                    boxShadow: selected ? 'inset 0 -100px 0 rgba(33,133,208,.15)' : '',
                }}
            >
                {disabled ? '' : text}{' '}
            </td>
            {currentModal}
        </>
    )
}

// export class ImageComponent extends React.PureComponent<GridImageProps, GridImageState> {
//   constructor (props) {
//     super(props)
//     this.handleChange = this.handleChange.bind(this)
//     this.onChange = this.onChange.bind(this)
//     this.state = {value: this.props.dataItem[this.props.field], currentModal: null}
//   }

//   // static getDerivedStateFromProps(props, current_state) {
//   //   if(props.dataItem[this.props])
//   // }

//   onChange = (e,value) => {
//     this.props.onChange({ dataItem: this.props.dataItem, syntheticEvent: e, field: this.props.field, value: value});
//   }

//   handleChange (opt) {
//   //   const {onCommit, onRevert} = this.props
//   //   if (!opt) {
//   //     return onRevert()
//   //   }
//   //   const { e } = this.state
//   //   onCommit(opt.value, e)
//   }

//   render () {
//     let value = this.state.value
//     let cellField = 'Image'
//     let dataItem = this.props.dataItem
//     let partKey = dataItem["Partkey"]
//     let imageSrc = typeof value === "boolean" ? PART_IMAGE_URL + partKey : value
//     let text = value ? "Yes" : "No"
//     const selected = this.props.dataItem["selected"] && this.props.dataItem.selectedColumns[this.props.field];
//     const {onMouseOver, onMouseDown, onMouseUp} = dataItem
//     return (
//       <>
//       <td
//         onClick={(e)=>{
//           e.persist()
//           this.setState({currentModal: <ImageDialog open={true} close={()=>this.setState({currentModal: null})} onSave={(value) => {this.onChange(e, value)}} src={imageSrc} /> })
//         }}
//         onMouseDown={(e) => { onMouseDown(e, dataItem, cellField)}}
//         onMouseOver={(e) => { onMouseOver(e, dataItem, cellField)}}
//         onMouseUp={(e) => { onMouseUp(e, dataItem, cellField); }}
//         style={{boxShadow: (selected ? "inset 0 -100px 0 rgba(33,133,208,.15)" : "")}}
//       >
//       {text} </td>
//       {this.state.currentModal}
//       </>
//     )
//   }
// }
export const DQIDropDown: React.FC<GridCellProps> = (props) => {
    let values = ['', '1', '2', '3', '4', '5', '6']
    const value = props.dataItem[props.field]
    const selected = props.dataItem['selected'] && props.dataItem.selectedColumns[props.field]
    const cellField = props.field
    let dataItem = props.dataItem
    let disabled = !!!dataItem['Part Number']
    const { onMouseOver, onMouseDown, onMouseUp } = dataItem
    const onChange = (e: DropDownListChangeEvent) => {
        props.onChange({
            dataItem: props.dataItem,
            syntheticEvent: e.syntheticEvent,
            field: props.field,
            value: e.value,
        })
    }
    return (
        <td
            style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                boxShadow: selected ? 'inset 0 -100px 0 rgba(33,133,208,.15)' : '',
            }}
            onMouseDown={(e) => {
                onMouseDown(e, dataItem, cellField)
            }}
            onMouseOver={(e) => {
                onMouseOver(e, dataItem, cellField)
            }}
            onMouseUp={(e) => {
                onMouseUp(e, dataItem, cellField)
            }}
        >
            <DropDownList
                data={values}
                defaultValue={value}
                onChange={onChange}
                style={{ width: 'unset' }}
                disabled={disabled}
            />
        </td>
    )
}

export const Checkbox: React.FC<GridCellProps> = (props) => {
    const checked = props.dataItem[props.field]
    const selected = props.dataItem['selected'] && props.dataItem.selectedColumns[props.field]
    const cellField = props.field
    let dataItem = props.dataItem
    const { onMouseOver, onMouseDown, onMouseUp } = dataItem
    let disabled = !!!dataItem['Part Number']

    const onChange = (e: CheckboxChangeEvent) => {
        props.onChange({
            dataItem: props.dataItem,
            syntheticEvent: e.syntheticEvent,
            field: props.field,
            value: e.value,
        })
    }
    return (
        <td
            style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                boxShadow: selected ? 'inset 0 -100px 0 rgba(33,133,208,.15)' : '',
            }}
            onMouseDown={(e) => {
                onMouseDown(e, dataItem, cellField)
            }}
            onMouseOver={(e) => {
                onMouseOver(e, dataItem, cellField)
            }}
            onMouseUp={(e) => {
                onMouseUp(e, dataItem, cellField)
            }}
        >
            <KCheckbox checked={checked} onChange={onChange} disabled={disabled} />
        </td>
    )
}

export class PartTypeahead extends React.Component<GridPartProps, GridPartState> {
    constructor(props: GridCellProps) {
        super(props)
        this.handleSearch = _.debounce(this.handleSearch.bind(this), 200, false)
        // this.handleSearch = this.handleSearch.bind(this)
        this.state = {
            value: props.dataItem[props.field],
            originalValue: props.dataItem[props.field],
            loading: false,
            options: [],
            focused: false,
        }
    }
    static getDerivedStateFromProps(props, current_state) {
        if (current_state.originalValue !== props.dataItem[props.field]) {
            return {
                value: props.dataItem[props.field],
                originalValue: props.dataItem[props.field],
            }
        }
        return null
    }

    componentDidUpdate(prevProps) {
        let oldSelected = prevProps.dataItem.selected
        let oldCellField = prevProps.field
        const cellField = 'Part Number'
        const dataItem = this.props.dataItem
        const inEditField = dataItem['inEdit'] === 'Part Number'
        if (
            prevProps.dataItem['inEdit'] === 'Part Number' &&
            dataItem['inEdit'] !== 'Part Number' &&
            (prevProps.dataItem[cellField] !== this.state.value ||
                (this.props.dataItem.lastValidValue &&
                    this.state.value !== this.props.dataItem.lastValidValue))
        ) {
            const value = this.state.value
            let e = { dataItem: dataItem, field: cellField, value: value }
            this.onBlur(e)
        }
    }

    handleSearch = (query) => {
        this.setState({ loading: true })

        fetch(`${PART_SEARCH_URI}/${query}`, {
            credentials: 'include',
        })
            .then((resp) => resp.json())
            .then((json) => {
                // alert(json)
                // const options = items.map((i) => ({
                //   avatar_url: i.avatar_url,
                //   id: i.id,
                //   login: i.login,
                // }));
                this.setState({ options: json, loading: false })
            })
    }

    validatePart = (query) => {
        this.props.dataItem.setRowLoading(this.props.dataItem.index, true)
        return fetch(`${PART_SEARCH_URI}/${query}`, {
            credentials: 'include',
        })
            .then((resp) => resp.json())
            .then((json) => {
                if (!json.includes(query)) {
                    return false
                }

                return true
            })
    }

    // onOpen = () => { this.log('open'); }
    // onClose = () => { this.log('close'); }
    // onFocus = () => { this.log('focus'); }
    onBlur = (e) => {
        // also compare to last valid value in case of forcing input
        if (
            this.state.value !== this.props.dataItem[this.props.field] ||
            (this.props.dataItem.lastValidValue &&
                this.state.value !== this.props.dataItem.lastValidValue)
        ) {
            if (this.state.value !== '') {
                if (this.props.dataItem.partNumbers[this.state.value]) {
                    alert(`The part number ${this.state.value} is already in the table\n`)
                    this.setState({ value: '' })
                    return
                }
                this.validatePart(this.state.value).then((valid) => {
                    if (valid) {
                        this.props.onChange({
                            dataItem: this.props.dataItem,
                            syntheticEvent: e,
                            field: this.props.field,
                            value: this.state.value,
                        })
                    } else {
                        alert(`Part ${this.state.value} does not exist`)
                        // lastValidValue is set if we jumped in from key input
                        this.setState({ value: this.props.dataItem[this.props.field] })
                        this.props.dataItem.setRowLoading(
                            this.props.dataItem.index,
                            false,
                            this.props.dataItem.lastValidValue
                        )
                    }
                })
            } else {
                this.props.onChange({
                    dataItem: this.props.dataItem,
                    syntheticEvent: e,
                    field: this.props.field,
                    value: this.state.value,
                })
            }
        }
        this.setState({ focused: false })
    }

    // careful about focus since hitting "X" on the autocomplete will never trigger blur
    onChange = (event) => {
        let value = event.target.value.toUpperCase()
        if (value !== '') {
            this.handleSearch(value)
            this.setState({ value: value })
        } else {
            if (this.state.focused) {
                this.setState({ value: value })
            } else {
                this.props.onChange({
                    dataItem: this.props.dataItem,
                    syntheticEvent: event,
                    field: this.props.field,
                    value: value,
                })
            }
        }
    }

    onClose = (event) => {
        let value = event.target.value.toUpperCase()
        if (value.trim().length === 0) return
        if (this.props.dataItem.partNumbers[value]) {
            alert(`The part number ${value} is already in the table\n`)
            this.setState({ value: '' })
            return
        }
        this.validatePart(value).then((valid) => {
            if (valid) {
                this.props.onChange({
                    dataItem: this.props.dataItem,
                    syntheticEvent: event,
                    field: this.props.field,
                    value: value,
                })
            } else {
                alert(`Part ${value} does not exist`)
                this.setState({ value: this.props.dataItem[this.props.field] })
                this.props.dataItem.setRowLoading(
                    this.props.dataItem.index,
                    false,
                    this.props.dataItem.lastValidValue
                )
            }
        })
    }

    onFocus = (event) => {
        this.setState({ focused: true })
    }

    render() {
        // const ke = new KeyboardEvent("keydown", {
        //   bubbles: true, cancelable: true, key: 'ArrowDown'
        // });
        //   ke.initEvent('keypress', true, false)

        const dataItem = this.props.dataItem
        const inEditField = dataItem['inEdit'] === 'Part Number'
        const cellField = 'Part Number'
        const selected = dataItem['selected'] && dataItem.selectedColumns['Part Number']

        const { onMouseOver, onMouseDown, onMouseUp, handleContextMenu } = dataItem
        return (
            <td
                onMouseDown={(e) => {
                    onMouseDown(e, dataItem, cellField)
                }}
                onMouseOver={(e) => {
                    onMouseOver(e, dataItem, cellField)
                }}
                onMouseUp={(e) => {
                    onMouseUp(e, dataItem, cellField)
                }}
                onContextMenu={(e) => {
                    handleContextMenu(e, dataItem, 'Part Number')
                }}
                style={{
                    boxShadow: selected ? 'inset 0 -100px 0 rgba(33,133,208,.15)' : '',
                }}
                className={'awcgridcell'}
            >
                {inEditField ? (
                    <div
                        onMouseDown={(e) => e.stopPropagation()}
                        onMouseOver={(e) => e.stopPropagation()}
                    >
                        <AutoComplete
                            data={this.state.options}
                            ref={(input) => input && input.focus()}
                            // onOpen={this.onOpen}
                            onClose={this.onClose}
                            onFocus={this.onFocus}
                            // onBlur={this.onBlur}
                            onChange={this.onChange}
                            value={this.state.value}
                            focusedItemIndex={() => -1}
                            style={{ width: '90%' }}
                        />
                    </div>
                ) : (
                    <span className={'awcgridcell'}>{this.state.value}</span>
                )}
            </td>
        )
    }
}
